import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import StoreGrid from "../components/storegrid"
import { Store } from "../data/store"

const All = () => (
  <Layout>
    <SEO title="All" />
    <div className="homepageBlurb">
			<h1>All Hampers</h1>
			<p>These hampers make the perfect gift for new parents, new babies & every occasion around the new arrival.
      <br></br>With lots of cute items, designs and colours, you're sure to find that perfect present.
      <br></br>All of these hampers are built for you ready just to personalise.
      <br></br>Looking for inspiration?
      <br></br>Our Giraffe, Dinosaur, Bunny and Floral Hampers are really popular! </p>
		</div>
    <StoreGrid products={Store} />
  </Layout>
)

export default All
